import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faSignOut, faPlus, faUsers, faFileChartLine, faUser, faBuilding, faCog, faHome, faSearch, faUserTie, faCalendarAlt,
  faTasks, faChevronDoubleRight, faChevronDoubleLeft, faFolders, faHouse, faPoundSign, faGavel, faEnvelope, faBell, faFileInvoice,
faFolderOpen, faFileAlt, faPause, faQuestionCircle, faCheckCircle, faTimesCircle, faArchive, faChevronUp, faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { AuthService } from 'src/app/auth/auth.service';
import { SidebarService } from 'src/app/shared/components/sidebar/sidebar.service';


@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.scss']
})
export class MainSidebarComponent implements OnInit {

  faHome = faHome;
  faSignOut = faSignOut;
  faPlus = faPlus;
  faUsers = faUsers;
  faBuiling = faBuilding;
  faFileChartLine = faFileChartLine;
  faUser = faUser;
  faCog = faCog;
  faSearch = faSearch;
  faUserTie = faUserTie;
  faCalendarAlt = faCalendarAlt;
  faTasks = faTasks;
  faChevronDoubleRight = faChevronDoubleRight;
  faChevronDoubleLeft = faChevronDoubleLeft;
  faFolders= faFolders;
  faHouse = faHouse;
  faPoundSign = faPoundSign;
  faGavel = faGavel;
  faEnvelope= faEnvelope;
  faBell = faBell;
  faFileInvoice = faFileInvoice;
  faFolderOpen = faFolderOpen;
  faFileAlt = faFileAlt;
  faPause = faPause;
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  faQuestionCircle = faQuestionCircle;
  faArchive = faArchive;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;

  isSmall = false;
  isMedium = false;
  showSidebar = false;
  hideContent = true;

  casesExpanded: boolean = true;

  constructor(public authService: AuthService, breakpointObserver: BreakpointObserver, private sidebarService: SidebarService, public router: Router) {

    sidebarService.showSideBarObservable.subscribe(result => {
      this.showSidebar = result;
    });
   }

  ngOnInit() {
  }

  showSideBarContent() {

  }

  toggleSideBar(){
    this.hideContent = true;
    this.isSmall = true;
    this.sidebarService.toggleSideBar();
  }

  toggleCases() {
    this.casesExpanded = !this.casesExpanded;
  }

  navigateToCases(event: Event) {
  event.stopPropagation();
  this.router.navigate(['/cases']);
}

}
